<template>
  <div>
    <div
      class="container inchange-h"
      style="background:#fff;width:100%;border-radius:30px;margin: 10px auto;"
    >
      <div style="padding-top:20px">
        <h5>
          <b-breadcrumb :items="Navitems"></b-breadcrumb>
        </h5>
      </div>
      <!-- <img src="../../static/images/logo.png" alt="" class="DescLogo"> -->
      <div class="text-center">
        <div v-if="$i18n.locale === 'zh'">
          <h3 class="ProName" style="font-weight:600">{{ title }}</h3>
        </div>
        <div v-if="$i18n.locale === 'en'">
          <h3 class="ProName" style="font-weight:600">{{ englishName }}</h3>
        </div>
      </div>
      <b-row
        class="Pro_main"
        style="background:linear-gradient(to right, #000000 00%,#ffffff 130%);padding:20px 0"
      >
        <b-col class="colpic">
          <viewer>
            <b-img :src="bigimg" fluid class="Productimg"></b-img>
          </viewer>
        </b-col>
        <b-col>
          <div style="font-size:16px">
            <div class="Protable">
              <b-table
                striped
                hover
                stacked
                :items="items"
                style="color:#fff"
              ></b-table>
            </div>
            <div v-if="$i18n.locale === 'zh'" style="color:#fff">
              <div v-html="detail">{{ detail }}</div>
            </div>
            <div v-if="$i18n.locale === 'en'" style="color:#fff">
              <div v-html="englishDetail">{{ englishDetail }}</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="title == 'M550CNC磨齿机'" class="p-2" style="">
      <div
        class="container"
        style="background:#fff;height:auto;margin-top:50px;padding-bottom: 50px;border-radius:30px;background:linear-gradient(to top, #666666 00%,#ffffff 130%)"
      >
        <div style="padding-bottom:20px;padding-top:30px" class="text-center">
          <h3>详细参数</h3>
          <div class="commendline"></div>
        </div>
        <div>
          <b-row>
            <b-col style="margin: 0 auto;">
              <viewer>
                <b-img
                  src="http://imgs.pioneertools.com/Img/M55CNC参数-2.jpg"
                  fluid
                ></b-img>
              </viewer>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="margin: 0 auto;">
              <viewer>
                <b-img
                  src="http://imgs.pioneertools.com/Img/M55CNC参数.jpg"
                  fluid
                ></b-img>
              </viewer>
            </b-col>
          </b-row>

          <div class="ParamsPic cncpic">
            <viewer :images="mainImg">
              <b-row v-for="(items, index) in mainImg" :key="index">
                <b-col
                  class="text-center"
                  v-for="(item, subindex) in items"
                  :key="subindex"
                >
                  <b-img
                    :src="item.src"
                    class="cncborderline"
                    style="width:98%"
                  >
                  </b-img>
                </b-col>
              </b-row>
            </viewer>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container"
      style="background:#fff;height:400px;margin-top:50px;margin-bottom:50px;border-radius:30px"
    >
      <div style="padding-bottom:20px;padding-top:20px" class="text-center">
        <h3>为您推荐</h3>
        <div class="commendline"></div>
      </div>
      <div>
        <el-carousel :interval="4000" type="card" height="300px">
          <el-carousel-item
            v-for="(item, subindex) in otherPros"
            :key="subindex"
          >
            <div @click="jump(item.productId, item.productName)">
              <b-img
                fluid
                :src="item.productImg"
                class="recommendImg"
                ref="Imgs"
              ></b-img>
              <div class="Cardline"></div>
              <p class="productName" style="text-align:center;font-size:16px">
                {{ item.productName }}
              </p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { postRequest } from "../../main";
export default {
  name: "prodetail",

  data() {
    return {
      mainImg: [
        [
          { src: require("../../../static/Updatedimg/M55CNCshow-2.jpg") },
          { src: require("../../../static/Updatedimg/M55CNCshow-1.jpg") },
        ],
        [
          { src: require("../../../static/Updatedimg/M55CNCshow-3.jpg") },
          { src: require("../../../static/Updatedimg/M55CNCshow-4.jpg") },
        ],
      ],
      cur_page: 1,
      otherPros: [],
      items: [{ 品牌: "Pioneer", 类型: "111", 名称: "1" }],
      Navitems: [
        {
          text: "产品展示",
          to: { name: "product" },
        },

        {
          text: "",
          active: true,
        },
      ],
      lang: "",
      Proclass: "",
      title: "",
      id: "",
      detail: "",
      bigimg: "",
      temp: "",
      englishtemp: "",
      englishName: "",
      englishDetail: "",
      tempId: 51,
      picurl: "http://imgs.pioneertools.com",
      is_search: false,
      ProHeadImg: {
        src: require("../../../static/images/carousel_3.jpg"),
      },
    };
  },
  methods: {
    getProById() {
      this.is_search = true;
      postRequest("http://houtai.pioneertools.com/public/selectProductById", {
        id: this.tempId,
      }).then((res) => {
        console.log(res);
        let data = res.data.data;

        this.title = data.productName;
        this.temp = data.productDescription;
        this.englishtemp = data.productEnglishDescription;
        this.bigimg =
          "http://imgs.pioneertools.com" +
          data.productImg.replace("sxito/", "");
        this.detail = this.temp.replace(/\n|\r\n/g, "<br/>");
        this.englishDetail = this.englishtemp.replace(/\n|\r\n/g, "<br/>");
        this.englishName = data.productEnglishName;
        this.Proclass = data.productClassification;
        this.Navitems[1].text = this.title;
        this.items[0].名称 = this.title;

        if (this.Proclass == "1") {
          this.items[0].类型 = "高速钢圆锯片 ";
        } else if (this.Proclass == "2") {
          this.items[0].类型 = "TCT冷切锯片  ";
        } else if (this.Proclass == "3") {
          this.items[0].类型 = "数控磨齿机   ";
        }
      });
    },
    getNearProduct() {
      postRequest("http://houtai.pioneertools.com/public/getAllProduct", {
        page: this.cur_page,
      }).then((res) => {
        console.log(res);
        let data = res.data.data.list;
        let homeProduct = [];
        for (let i = 0; i < 8; i++) {
          // data[i].productDescription = data[i].productDescription.substring(0,20)+"..."

          data[i].productImg =
            this.picurl +
            data[i].productImg.replace("sxito/productImg", "piotoolsmin");
          homeProduct[i] = data[i];
        }

        this.otherPros = homeProduct;
      });
    },
    jump(id, title) {
      this.$router.push({
        name: "prodetail",
        params: {
          id: id,
          title: title,
        },
      });
      this.$router.go(0);
      router.afterEach((to, from, next) => {
        window.scrollTo(0, 0);
      });
    },
  },

  mounted: function() {
    this.id = this.$route.params.id;
    this.title = this.$route.params.title;
    this.tempId = parseInt(this.id);
    console.log(this.tempId);

    this.getProById();
    this.getNearProduct();

    console.log(this.otherPros);
  },
};
</script>

<style>
.topPic {
  width: 100%;
  height: 300px;
}
.inchange-h {
  height: 700px;
}
@media (max-width: 991px) {
  .inchange-h {
    height: auto;
  }
}
.cncpic .col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.cncborderline {
  border: 3px outset #666 !important;
}
.Pro_main {
  padding-top: 20px;
}
.ProName {
  padding-top: 20px;
  padding-bottom: 20px;
}
/* .container h2{
        visibility: hidden;
        animation: top-bottom 1s linear forwards;
    } */
.DescLogo {
  visibility: hidden;
  animation: bottom-top 1s linear forwards;
  padding-right: 30px;
  width: 50%;
}
.DescLogo2 {
  width: 100%;
}

.commendline {
  border: 2px solid #666;
  width: 100px;

  margin: 4px auto;
}
.jinshubg {
  background: url("../../../static/images/proitembg2.jpg");
  background-position: center;
}
.colpic {
  flex-basis: 0;
  -ms-flex-positive: 1;
  -webkit-box-flex: 1;
  flex-grow: 1;
  max-width: 100%;
}
@media (max-width: 991px) {
  .colpic {
    flex-basis: auto !important;
  }
}
.Productimg {
  max-width: 98% !important;
  padding-left: 2%;
}
.productName {
  cursor: pointer;
}
.productName:hover {
  color: #2d8cf0;
}
.Protable {
  padding: 20px 0;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #c0c4cc;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #e4e7ed;
}
.recommendImg {
  width: 75%;
  padding-left: 25%;
  padding-top: 0px;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -o-transition: all 1s;
}
.el-carousel__container {
  height: 300px;
}
@media (max-width: 768px) {
  .el-carousel__container {
    height: 220px !important;
  }
  .recommendImg {
    width: 80%;
    padding-left: 20%;
    padding-top: 30px;
  }
  .cncborderline {
    max-height: 139.28px !important;
  }
}
@media (min-width: 802px) {
  .cncborderline {
    max-height: 416.69px !important;
  }
}
.table.b-table.b-table-stacked > tbody > tr > :first-child {
  border-top-width: 1px !important;
}
</style>
